import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as authAPI from "../../api/auth";

export const ROLES = ["Staff", "admin", "superAdmin"];
const getAuthState = (state) => state.auth;
/*
 Staff: userRoutes,
  admin: adminRoutes,
  superAdmin: superAdminRoutes,
  undefined: unauthorizedRoutes,

*/
const initialState = {
  isAuth: false,
  token: null,
  refreshToken: null,
  role: "undefined",
  status: null, // "loggingIn" | "loggingOut" | "sessionExpired"
  expires: null,
  refreshTokenExpiresIn: null,
  error: null,
  admin: false,
  loginUsername: "",
  ui: {
    loading: false,
  },
  userId: null,
  institutionId: null,
};

const login = createAsyncThunk(
  "auth/login",
  async (params, { rejectWithValue }) => {
    try {
      const res = await authAPI.login(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const signup = createAsyncThunk(
  "auth/signup",
  async (params, { rejectWithValue }) => {
    try {
      const res = await authAPI.signup(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
        toast.success("Password reset successfully");
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const reset = createAsyncThunk(
  "auth/reset",
  async (params, { rejectWithValue }) => {
    try {
      const res = await authAPI.reset(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const forgot = createAsyncThunk("auth/forgot", async (params) => {
  try {
    const res = await authAPI.forgot(params);
    return res.data.body;
  } catch (error) {
    //console.log("forgot", error);
  }
});

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,

  reducers: {
    persistLogin: (state) => {
      // if (isLocalStorageAvailable()) {
      // const token = localStorage.getItem("persist:auth");
      // const expires = localStorage.getItem("expires");
      // if (token) {
      //   state.isAuth = true;
      //   state.token = token;
      //   if (expires) {
      //     state.expires = expires;
      //   }
      // }
      state.status = "idle";
      // }
    },
    resetAuth: (state) => {
      state.isAuth = false;
      state.token = null;
    },
    setRefreshedTokenData: (state, action) => {
      //console.log("setRefreshedTokenData ===>", action.payload);
      state.ui.loading = false;
      state.token = action.payload.accessToken;
      state.expires = action.payload.expiresIn;
      state.isAuth = true;
      state.refreshToken = action.payload.refreshToken;
      state.refreshTokenExpiresIn = action.payload.refreshTokenExpiresIn;
      state.role = action.payload.userType; // changed it based on role staff or admin
    },
    userregister: (state) => {
      state.isAuth = false;
      state.token = null;
      state.expires = null;
      state.status = "unregistered";
    },
    logout: () => {
      return initialState;
    },
    sessionExpired: (state) => {
      // if (isLocalStorageAvailable()) {
      //   localStorage.removeItem("token");
      //   localStorage.removeItem("expires");
      // }
      state.isAuth = false;
      state.token = null;
      state.status = "sessionExpired";
      state.expires = null;
      state.error = "sessionExpired";
    },
    setAdminAccess: (state, { payload }) => {
      state.admin = payload;
    },
    changeRole: (state, action) => {
      const { role, institutionId } = action.payload;
      if (role) state.role = role;

      if (institutionId) state.institutionId = institutionId;
    },
  },

  extraReducers: {
    [login.pending]: (state) => {
      state.ui.loading = true;
    },
    [login.fulfilled]: (state, action) => {
      //console.log("action", action);
      state.ui.loading = false;
      state.loginUsername = action.meta.arg.username;
      state.token = action.payload.accessToken;
      state.expires = action.payload.expiresIn;
      state.isAuth = true;
      state.refreshToken = action.payload.refreshToken;
      state.refreshTokenExpiresIn = action.payload.refreshTokenExpiresIn;
      state.role = ROLES.includes(action.payload.userType)
        ? action.payload.userType
        : "undefined"; // changed it based on role staff or admin  ; // changed it based on role staff or admin
      state.userId = action.payload.userId;
      if (action.payload.userType === ROLES[2]) {
        state.admin = true;
      } else {
        state.admin = false;
      }
      state.institutionId = action.payload.institutionId;
    },
    [login.rejected]: (state) => {
      state.isAuth = false;
      state.ui.loading = false;
      state.loginUsername = "";
    },

    [reset.pending]: (state) => {
      state.loading = true;
    },
    [reset.fulfilled]: (state) => {
      state.loading = false;
    },
    [reset.rejected]: (state) => {
      state.loading = false;
    },

    [forgot.pending]: (state) => {
      state.loading = true;
    },
    [forgot.fulfilled]: (state) => {
      state.loading = false;
    },
    [forgot.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const {
  persistLogin,
  logout,
  sessionExpired,
  setRefreshedTokenData,
  resetAuth,
  setAdminAccess,
  changeRole,
} = authSlice.actions;

export default authSlice.reducer;

export {
  persistLogin,
  logout,
  sessionExpired,
  getAuthState,
  login,
  signup,
  setRefreshedTokenData,
  reset,
  forgot,
  resetAuth,
  setAdminAccess,
  changeRole,
};
